export const API_BASE = process.env.REACT_APP_API_URL;

export const FALLBACK_COVER_IMG = "/img/not-found-placeholder.png";
